import React from 'react';
import { observer, inject } from 'mobx-react';
import CellType from './CellType'
import * as Parse from '../../util/public/parseLayout';
import * as _ from '../../util/public/common';
import { getEcCom,getLabel } from '../../util/convert';
import * as DetailUtil from '../../util/public/detailUtil';

@inject('globalStore', 'layoutStore')
@observer
export default class LayoutTr extends React.Component {
    shouldComponentUpdate(nextProps){
        if(this.props.symbol === nextProps.symbol && this.props.symbol.indexOf("detail") > -1){
            //明细特殊处理，解决选中、添加行渲染所有字段问题
            return !_.isEqual(this.props.detailProps, nextProps.detailProps) || !_.isEqual(this.props.rowMergeInfo, nextProps.rowMergeInfo);
        }
        return true;
    }
    componentDidMount(){
        const { symbol,detailProps={} } = this.props;
        if(symbol.indexOf("detail_") > -1){
            //明细锁定列，加载时渲染完最后一行，则同步一次高度宽度
            const groupid = parseInt(symbol.substring(7)) - 1;
            const { lockedFlag,isLastRow } = detailProps;
            if(lockedFlag === 2 && isLastRow === true)
                DetailUtil.syncLockedForDidMount(groupid); 
        }
    }
    render() {
        const { JSComplete } = this.props.globalStore;
        const { symbol,colNum,rowid,rowHeight,rowCusAttr,colattrs,ecMap,detailProps={},nodeSignProps={},dataRows,rowMergeInfo } = this.props;
        const { rowType,addColType,rowIndex="",serialNum,needHide,lockedFlag=0,lockedColumn=-1 } = detailProps;      //明细解析相关
        const isDetail = symbol.indexOf("detail_") > -1;
        let colid = 0;
        let cellArr = new Array();
        const isVirtualSum = isDetail && addColType === 4;   //低级模式，虚拟生成合计行
        while(colid < colNum) {     //从行第一列正序解析
            const isVirtualSerial = isDetail && colid === 0 && addColType > 0;     //低级模式，虚拟生成的序号列
            const isRowMergeCell = Parse.judgeCellBelRowSpan(symbol,rowid,colid,ecMap);    //是否行合并单元格
            const isLockedHoverCell = lockedFlag === 2 && colid <= lockedColumn;    //属于锁定列被遮罩的单元格
            let cellObj = ecMap[rowid+","+colid];
            if((isRowMergeCell || !cellObj) && !isVirtualSerial && !isVirtualSum) {
                if(!isRowMergeCell){    //行合并单元格不生成td
                    const colCusAttr = colattrs ? colattrs["col_"+colid] : null;
                    const tdCellAttr = Parse.getCellAttr(null, colCusAttr, rowHeight);
                    cellArr.push(<td className={tdCellAttr.tdClass} style={tdCellAttr.tdStyle}></td>);
                }
                colid += 1;
            } else {
                let tdClassName = `${symbol === "main" ? "mainTd" : symbol}_${rowid}_${colid}`;
                //低级模式扩展序号列
                if(isVirtualSerial){

                    if(isRowMergeCell || !cellObj)    //扩展序号单元格为空时虚拟个CellObj对象
                        cellObj = {id: `${rowid},0`, etype: "1"};
                    if(addColType === 1){
                        cellArr.push(<td className={tdClassName}></td>);
                    }else if(addColType === 2){     //全选，模拟高级模式etype=20
                        let cellObjNew = _.cloneDeep(cellObj);
                        cellObjNew.etype = "20";
                        tdClassName += " detailtitle_td_swap"
                        cellArr.push(<td className={tdClassName}>
                                        <CellType ecId={`${this && this.props && this.props.ecId || ''}_CellType@z4ezjy@${symbol}_20`}
                                            symbol={symbol}
                                            cellObj={cellObjNew}
                                            detailProps={detailProps}
                                        />
                                        <span>{getLabel(15486,'序号')}</span>
                                    </td>);
                    }else if(addColType === 3){     //单选，模拟高级模式etype=21
                        let cellObjNew = _.cloneDeep(cellObj);
                        cellObjNew.etype = "21";
                        cellArr.push(<td className={tdClassName}>
                                        <CellType ecId={`${this && this.props && this.props.ecId || ''}_CellType@7zuihp@${symbol}_21`}
                                            symbol={symbol}
                                            cellObj={cellObjNew}
                                            detailProps={detailProps}
                                        />
                                        <span className="detailSerial">{serialNum}</span>
                                    </td>);
                    }else if(addColType === 4){     //合计行
                        cellArr.push(<td className={tdClassName}><span>合计</span></td>);
                    }
                    if(isRowMergeCell&&addColType !== 4){
                        colid += 1;
                        continue;
                    }
                }
                if(isVirtualSum){    //取字段内容行模拟生成合计字段
                    cellObj = _.cloneDeep(ecMap[(rowid+2)+","+colid]);
                    _.merge(cellObj, {"etype":"19", "rowspan":"1", "colspan":"1"})
                }
                let rowSpan = parseInt(cellObj.rowspan || 1);
                const colSpan = parseInt(cellObj.colspan || 1);
                //字段行合并
                if(rowSpan === dataRows && cellObj.etype == "3" && rowMergeInfo){
                    const mergeKey = `field${cellObj.field.toString()}`;
                    if(mergeKey in rowMergeInfo){
                        rowSpan = rowSpan * parseInt(rowMergeInfo[mergeKey]);
                        if(rowSpan === 0){
                            colid += parseInt(colSpan);
                            continue;
                        }
                    }
                }
                const colCusAttr = colattrs ? colattrs["col_"+colid] : null;
                const tdCellAttr = Parse.getCellAttr(cellObj, colCusAttr, rowHeight);
                tdClassName += ` etype_${cellObj.etype}`;
                if(tdCellAttr.tdClass)
                    tdClassName += " "+tdCellAttr.tdClass;
                if(isVirtualSum)
                    tdCellAttr.divStyle["color"] = "#FF0000";
                const cellAttr = Parse.buildCellAttr(tdCellAttr, tdCellAttr.cusclass, tdCellAttr.divStyle);
                cellArr.push(<td rowSpan={rowSpan} colSpan={colSpan} className={tdClassName} style={tdCellAttr.tdStyle}>
                                {
                                    !isLockedHoverCell && 
                                        <CellType ecId={`${this && this.props && this.props.ecId || ''}_CellType@27chqt@${symbol}_${rowid}_${colid}`}
                                            symbol={symbol}
                                            cellAttr={cellAttr}
                                            cellObj={cellObj}
                                            detailProps={detailProps}
                                            nodeSignProps={nodeSignProps}
                                        />
                                }
                            </td>);
                colid += parseInt(colSpan);
            }
        }
        const rowAttr = Parse.getRowAttr(rowHeight, rowCusAttr);
        let trClass = rowAttr["trClass"] || "";
        if(isDetail){
            if(!!serialNum)      //明细奇偶行加class方便二开重写
                trClass += " " + (serialNum%2 === 0 ? "detail_even_row detail_data_row" : "detail_odd_row detail_data_row");
            if(needHide === true)
                trClass += " interface_hide";
        }else{
            if(this.judgeNeedHideRow())
                trClass += " linkage_hide";
            if(this.judgePrintHideEmptyDetail())
                trClass += " printEmptyDetail_hide";
        }
        const trProps = {id:rowAttr.id, name:rowAttr.name, className:trClass, style:rowAttr.trStyle};
        if(isDetail){
            if(rowType === 2)
                trProps["data-rowindex"] = rowIndex;
            if(lockedFlag > 0){
                if(rowType === 2)
                    trProps["data-rowkey"] = `${rowIndex}_${rowid}`;
                else
                    trProps["data-rowkey"] = `${rowType === 1 ? "headRow" : "tailRow"}_${rowid}`;
                trProps["data-rowheight"] = trProps.style.height || "30px";
            }
        }
        return (
            <tr {...{...rowAttr.cusobj, ...trProps}}>{cellArr}</tr>
        )
    }
    judgeNeedHideRow(){     //显示属性联动隐藏行
        const { symbol,rowid,layoutStore } = this.props;
        const { cellInfo,variableMap } = layoutStore;
        const mainRowFields = cellInfo.mainRowFields || {};
        const rowKey = `${symbol}_row_${rowid}`;
        let hide = false;
        rowKey in mainRowFields && mainRowFields[rowKey].map(fieldid =>{
            if(variableMap.get(`field${fieldid}_viewAttr`) === 5)      //直接取map具体值优化性能
                hide = true;
        });
        return hide;
    }
    judgePrintHideEmptyDetail(){    //打印隐藏空明细
        let hide = false;
        const { globalStore,layoutStore } = this.props;
        const { commonParam } = globalStore;
        if(_.isEmpty(commonParam) || parseInt(commonParam.isprint) != 1)
            return false;
        const { rowSubPanelMap,detailMap } = layoutStore;
        const { symbol,rowid } = this.props;
        if(_.has(rowSubPanelMap, `${symbol}_${rowid}`)){
            const panelSymbol = rowSubPanelMap[`${symbol}_${rowid}`];
            if(panelSymbol.indexOf("detail_") > -1){
                const detailObj = detailMap.get(panelSymbol);
                if(detailObj && detailObj.attr.ishidenull !== 1 && detailObj.indexnum === 0)
                    hide = true;
            }
        }
        return hide;
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/layout/LayoutTr.js